/* Auto Generated */

export enum AdminApprovalStatus {
    pending,
    inReview,
    denied,
    approved,
    cancelled,
}
